// Entry point for the build script in your package.json
import '@hotwired/turbo-rails';
import './controllers';
import 'trix';
import '@rails/actiontext';

// Add custom actions for TurboStream
import { StreamActions } from '@hotwired/turbo';

StreamActions.redirect = function () {
  const url = this.getAttribute('url');
  window.Turbo.visit(url);
};
